// extracted by mini-css-extract-plugin
module.exports = {"page":"Legal_page__rm51z","document":"Legal_document__KMUlB","updated":"Legal_updated__CywYz"};